<template>
  <el-dialog
    title="咨询进度"
    :visible.sync="visible"
    top="25vh"
    width="600px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="进度内容" prop="description">
          <el-input
            v-model.trim="form.description"
            type="textarea"
            :autosize="{ minRows: 3 }"
            placeholder="请输入内容"
            maxlength="500"
            resize="none"
          ></el-input>
        </el-form-item>
        <p class="submit fn-text-center">
          <el-button type="primary" @click="handlerAddData('ruleForm')"
            >提交</el-button
          >
        </p>
        <el-form-item label="备注详情" v-if="counseList.length > 0">
          <div class="remark-list">
            <el-scrollbar>
              <ul>
                <li v-for="(item, idx) in counseList" :key="idx">
                  <span>{{ item.createTime }}</span>
                  <i>{{ item.description }}</i>
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    counselId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      visible: true,
      form: {
        description: ""
      },
      rules: {
        description: [isEmpty("请输入内容")]
      },
      counseList: [],
      isLoading: false
    };
  },
  created() {
    this.loadInfo();
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      this.$api("mentor", "addCounselRemark", {
        ...this.form,
        consultID: this.counselId
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadInfo();
          // this.$emit("complete", true);
        }
      });
    },

    // 加载数据接口
    loadInfo() {
      this.$api("mentor", "getCounselRemarkInfo", { id: this.counselId }).then(
        (res) => {
          const { code, message } = res;
          if (code === 0) {
            this.counseList = res.dataList;
          } else {
            this.$message.error(message);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.remark-list {
  ul {
    max-height: 320px;
    li {
      padding: 10px 0;
      line-height: 20px;
      display: flex;
      span {
        flex: none;
        padding-right: 20px;
      }
      i {
        font-style: normal;
        word-break: break-all;
      }
    }
  }
}
</style>
